import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/__generated__/AutomationPopupMenuContentQuery$parameters';
import type { AutomationPopupMenuContentQuery } from './ui/__generated__/AutomationPopupMenuContentQuery.graphql';

export const automationMenuContentEntrypoint: EntryPoint<
	EntryPointComponent<
		{
			mainQuery: AutomationPopupMenuContentQuery;
		},
		{},
		{
			onClose: () => void;
		},
		{}
	>,
	{
		cloudId: string;
		projectIdOrKey: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-automation-menu-content-entrypoint" */ './ui/AutomationPopupMenuContent'
		).then((module) => module.AutomationPopupMenuContent),
	),
	getPreloadProps: ({ cloudId, projectIdOrKey }: { cloudId: string; projectIdOrKey: string }) => {
		return {
			queries: {
				mainQuery: {
					parameters,
					variables: {
						cloudId,
						projectIdOrKey,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
